//./plugins/posthog.js
import posthog from "posthog-js";

export default {
    install(app) {
        app.config.globalProperties.$posthog = posthog.init(
            'phc_eYfL8QLhtDbulpwC6qKZ0lAy8b3PLH3tjMuDNsZElPG',
            {
                api_host: 'https://eu.i.posthog.com',
            }
        );
    },
};